import { environment } from 'src/environments/environment';

export const apiList = {
  login: {
    userLogin: 'api/v1/login',
    forgotPassword: 'api/v1/users/forgotPassword'
  },
  logOut: {
    logout: 'api/v1/logout',
  },
  refreshToken: {
    refresh_token: 'api/v1/refresh/token',
  },
  insurance: {
    payerRegistration: 'api/v1/payers',
    countryList: 'api/v1/country',
    currencyList: 'api/v1/currency',
    regulatorList: 'api/v1/regulator',
    languageList: 'api/v1/language',
    stateList: 'api/v1/state/{id}',
    listing: 'api/v1/payers',
    payerListing: 'api/v1/payer/account/{id}',
    city: 'api/v1/city/{id}',
    phoneCodes: 'api/v1/phonecodes',
    regenerateClientSecret: 'api/v1/communication/token',
    userExist: 'api/v1/user/exist',
  },
  provider: {
    listing: 'api/v1/providers',
    provRegistration: 'api/v1/providers',
    getEditProviderDetails: 'api/v1/providers/{id}',
    saveEditProviderDetails: 'api/v1/providers/{id}',
    providerListing: 'api/v1/provider/account/{id}',
    providerTypeListing: 'api/v1/providerType',
    specialityTypeLIsting: 'api/v1/speciality',

  },
  editPayer: {
    getEditpayerDetails: 'api/v1/payers/{id}',
    saveEditPayerDetails: 'api/v1/payers/{id}',
  },
  prescription: {
    transactionList: 'api/v1/transaction/client/{id}',
    transactionListCommon: 'api/v1/transactionList/{id}/0',
    transactionListRad: 'api/v1/transaction/client/rad/{id}',
    transactionListLab: 'api/v1/transaction/client/lab/{id}',
    providerList: 'api/v1/transaction/provider/{id}',
    payerList: 'api/v1/transaction/payer/{id}',
    getTransactionDetails: 'api/v1/transaction/{id}',
    getEport: 'api/v1/prescription/download',
    getAllTabs : 'api/v2/dynamicListGeneratorSettings',
  },
  drugList: {
    getDrugList: 'api/v1/drugListCode/{id}',
    getPayerDrugDetails: 'api/v1/preferredDrugList/payer/{id}',
    getProviderDrugDetails: 'api/v1/preferredDrugList/provider/{id}',
    getClientDrugDetails: 'api/v1/generalDrugList/{id}',
    addMasterDrug: 'api/v1/drugVersion',
    versionlist: 'api/v1/drugVersion',
    // getdrugDetails: 'api/v1/preferredDrugList/payer/{id}',
    updateVersion: 'api/v1/drugVersion/{id}',
    preferredList: 'api/v1/preferredDrugList/{id}',
    addPrefferredDrug: 'api/v1/preferredDrugList',
    updatePreffered: 'api/v1/preferredDrugList/{PayerPreferredDrugId}',
    downloadTemplate: 'api/v1/preferredDrugList/download',
  },
  rules: {
    getRuleList: 'api/v1/rules',
    getRuleListPayer: 'api/v1/rule/payer/{id}',
    getRuleListProvider: 'api/v1/rule/provider/{id}',
    getRuleConfigListClient: 'api/v1/ruleConfiguration/client/{id}',
    getRuleConfigListPayer: 'api/v1/ruleConfiguration/payer/{id}',
    getRuleConfigListProvider: 'api/v1/ruleConfiguration/provider/{id}',
    getRuleConfigDetailClient: 'api/v1/ruleConfiguration/detail/client',
    getRuleConfigDetailPayer: 'api/v1/ruleConfiguration/detail/payer',
    getRuleConfigDetailProvider: 'api/v1/ruleConfiguration/detail/provider',
    getDrugInHand: 'api/v1/drugInFormInhandExpiry',
    saveConfigClient: 'api/v1/ruleConfiguration/client',
    saveConfigPayer: 'api/v1/ruleConfiguration/payer',
    saveConfigProvider: 'api/v1/ruleConfiguration/provider',
    editRule: 'api/v1/ruleConfigurationVersion',
  },
  authorization: {
    getPreApprovalTransactionList: 'api/v1/transaction/client/preApproval/{id}',
    getPreApprovalTransactionListCommon: 'api/v1/transactionList/preApproval/{id}/0',
    getPreApprovalProviderList: 'api/v1/transaction/provider/preApproval/{id}',
    preApprovalPayerList: 'api/v1/transaction/payer/preApproval/{id}',
    getPreApprovalTransactionDetails: 'api/v1/transaction/{id}',
    setPreApprovalStatus: 'api/v1/transaction/{id}',
    getPreApprovalLabList: 'api/v1/transaction/client/preApproval/lab/{id}',
    getPreApprovalRadList: 'api/v1/transaction/client/preApproval/rad/{id}'
  },
  generalSettings: {
    getGeneralSetting: 'api/v2/generalSettings',
    setGeneralSetting: 'api/v1/generalSettings',
  },
  userManage: {
    userList: 'api/v1/users',
    userDetail: 'api/v1/users/{id}',
    postUser: 'api/v1/users',
    dowloadUserLog: 'api/v1/activityLog/download',
    physcianList: 'api/v1/users/physician',
    userType:'api/v1/userType'
  },
  role: {
    roles: 'api/v1/role',
    getRolesDetails:'api/v1/role/{id}',
  },
  clientRule: {
    getRuleListClient: 'api/v1/ruleConfigurationVersion/client/{id}',
  },
  customValidation: {
    getCustomValidationList: "api/v1/requestValidation",
    setValidationStatus: "api/v1/validationStatus"
  },
  validate: {
    tokenCheck: 'api/v1/users/validate',
    resetPassword: 'api/v1/users/resetPassword'
  },
  acl: {
    getPermissions: 'api/v1/permission/role',
    getAllPermissions: 'api/v1/permission',
  },
  ruleEngine: {
    declarations: 'api/v1/ruleEngine/declaration',
    functions: 'api/v1/ruleEngine/function',
    rules: 'api/v1/ruleEngine/rule/{id}',
    activeRules: 'api/v1/ruleEngine/rule/activate/{id}',
    getDraft: 'api/v1/ruleEngine/draft/{id}',
    getDroolCode: 'api/v1/ruleEngineApi/getRuleContent',
    putDrollCode: 'api/v1/ruleEngineApi/updateRuleContent',
    reloadDrool : 'api/v1/ruleEngineApi/reloadRules'
  },
  diagnosis:{
    getDiagnosisList:'/api/v1/diagnosisVersion',
    getDiagonsisDetails:'/api/v1/diagnosis',
    updateDiagnosis:'/api/v1/diagnosisVersion/{id}',
    addNewDiagnosis:'/api/v1/diagnosis/import',
    dowloadDiagnosis:'/api/v1/diagnosis/downloadTemplate'
    
  },
  allergy:{
    getAllergyList:'/api/v1/allergyVersion',
    getAllergyDetails:'/api/v1/allergy',
    updateAllergyCode:'/api/v1/allergyVersion/{id}',
    addNewAllergyCode:'/api/v1/allergy/import',
    dowloadAllergy:'/api/v1/allergy/downloadTemplate'
  },
  lockScreen:{
    lock : 'api/v1/lockCheck',
    unlocklock : 'api/v1/removeLock',
    tackOver : 'api/v1/lockTakeOver'
  }
};

export type GeneralKeyValue = {
  [key: string]: string | number | boolean | null;
};
export const getApiUrl = (
  relativeUrl: string,
  queryParams?: GeneralKeyValue | any | null,
  routeParams?: GeneralKeyValue | null,
  alternateEndpoint?: string
): string => {
  let url = `${alternateEndpoint ? alternateEndpoint : environment.apiDomain
    }/${relativeUrl}`;
  if (queryParams) {
    let params = '';
    url += setIfQueryParams(queryParams, params);
  }
  if (routeParams) {
    for (let key in routeParams) {
      if (routeParams[key]) {
        url = url.replace(`{${key}}`, routeParams[key] as string);
      }
    }
  }
  return url;
};

export const setIfQueryParams = (
  queryParams: GeneralKeyValue | any | null,
  params: string
) => {
  for (let key in queryParams) {
    if (
      queryParams[key] == null ||
      queryParams[key] == undefined ||
      queryParams[key] == ''
    )
      continue;
    params += params ? '&' : '?';
    if (Array.isArray(queryParams[key])) {
      queryParams[key].forEach((v: any, i: number) => {
        if (params && !params.endsWith('&') && !params.endsWith('?')) {
          params += '&';
        }
        params += `${key}=${v}`;
      });
    } else {
      if(typeof queryParams[key] == 'object'){
        params += `${key}=${JSON.stringify(queryParams[key])}`;
      }else{
        params += `${key}=${queryParams[key]}`;
      }
    }
  }
  return params;
};
